import type { RouteRecordRaw } from 'vue-router'
import { guardTicketAccess } from '@/config/router/navigationsGuards/guardTicket'

const MODULE_NAME = 'TICKET'
const MODULE_ID = 14

const ticketRoutes: Array<RouteRecordRaw> = [
  {
    path: '/tickets',
    name: 'Tickets',
    component: () => import('@/views/ticket/Index.vue'),
    meta: {
      requiresAuth: true,
      titleTranslationKey: 'pageTitle.tickets',
    },
    beforeEnter: [guardTicketAccess],
  },
]

export default ticketRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
